import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@talentmesh/ui/components/tooltip';
import { cn } from '@talentmesh/ui/lib/utils';
import React, { useCallback, useState } from 'react';
import { generatePath, Link } from 'react-router-dom';
import { useCandidatesOverviewContext } from '../../CandidatesOverviewContext/CandidatesOverviewContext';
import useCompanyId from '@/Hooks/UseCompanyId';
import RoutePath from '@/Routing/RoutePath';

interface ApplicantCellProps {
    id: string;
}

const ApplicantCell = ({ id, children }: React.PropsWithChildren<ApplicantCellProps>) => {
    const companyId = useCompanyId();
    const { assessmentId } = useCandidatesOverviewContext();
    const [isOverflowing, setIsOverflowing] = useState(false);
    const textRef = useCallback(
        (node: HTMLAnchorElement) => {
            // uncomment to enable the tooltip feature
            // setIsOverflowing(node?.scrollWidth > node?.clientWidth);
        },
        [setIsOverflowing],
    );

    return (
        <TooltipProvider>
            <Tooltip open={isOverflowing ? undefined : false}>
                <TooltipTrigger asChild>
                    <Link
                        ref={textRef}
                        to={generatePath(RoutePath.CandidateResult, { assessmentId, candidateId: id, companyId })}
                        className={cn(
                            'text-primary block max-w-full truncate text-left text-sm leading-normal font-semibold no-underline',
                            'hover:underline focus-visible:underline',
                        )}
                    >
                        {children}
                    </Link>
                </TooltipTrigger>
                <TooltipContent className="max-w-sm">{children}</TooltipContent>
            </Tooltip>
        </TooltipProvider>
    );
};

export default ApplicantCell;
